import { render, staticRenderFns } from "./ArticleRawMaterialsCompositionCard.vue?vue&type=template&id=74a0b495"
import script from "./ArticleRawMaterialsCompositionCard.vue?vue&type=script&lang=ts"
export * from "./ArticleRawMaterialsCompositionCard.vue?vue&type=script&lang=ts"
import style0 from "./ArticleRawMaterialsCompositionCard.vue?vue&type=style&index=0&id=74a0b495&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports